import { render, staticRenderFns } from "./courses.vue?vue&type=template&id=5f104902"
var script = {}
import style0 from "./courses.vue?vue&type=style&index=0&id=5f104902&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports